'use client';

import HomeDashboard from '@/app/components/HomeDashboard';
import HomeMarketing from '@/app/components/HomeMarketing';
import Loading from '@/app/components/Loading';
import { useUser } from '@clerk/nextjs';

const Page = () => {
  const { isLoaded, isSignedIn } = useUser();

  if (!isLoaded) return <Loading />;

  return isSignedIn ? <HomeDashboard /> : <HomeMarketing />;
};

export default Page;
